// extracted by mini-css-extract-plugin
export default {"formCard":"AddPost_formCard__W-Lbf","header":"AddPost_header__XQFUP","attributes":"AddPost_attributes__YmtGB","price":"AddPost_price__6hhjO"};